import React, { useReducer, useEffect, useCallback } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { initialState, reducer } from './reducer';
import { formValidator } from '../../../functions/validator';

const EditModal = (props) => {

    const [state, dispatch] = useReducer(reducer, initialState);

    const fetchUser = useCallback(async () => {
        const url = process.env.REACT_APP_API_URL;
        const authToken = sessionStorage.getItem('auth-token');

        const request = await fetch(`${url}/users/${props.user}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            });

        
        if (request.status === 200) {
            const response = await request.json();

            dispatch({ type: 'FETCH', name: response.name, lastname: response.lastname, phonenumber: response.phonenumber, role: response.rights });
        }

    }, [props.user]);

    const onSubmit = async (e) => {
        e.preventDefault();
        const hasError = formValidator(state, dispatch);
        if (!hasError) {
            const url = process.env.REACT_APP_API_URL;
            const authToken = sessionStorage.getItem('auth-token');

            const userData = {
                name: state.name.value,
                lastname: state.lastname.value,
                phonenumber: state.phonenumber.value,
                rights: state.role.value
            };

            const request = await fetch(`${url}/users/${props.user}`,
                {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${authToken}`
                    },
                    body: JSON.stringify(userData)
                });

            if (request.status === 200) {

                // Hide the modal
                props.hide();

                // This will reload the users
                props.refreshAccounts();

            }
        }
    };

    useEffect(() => {
        if (props.user && props.show) {
            fetchUser();
        }
    }, [props.show, props.user, fetchUser]);

    return (
        <Modal show={props.show} onHide={props.hide}>
            <Modal.Header closeButton>
                <Modal.Title>Editar Informacion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Entra el Nombre"
                            value={state.name.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'name', value: e.target.value })} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Apellido</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Entra el Apellido"
                            value={state.lastname.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'lastname', value: e.target.value })} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Telefono</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Entrar el Telefono"
                            value={state.phonenumber.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'phonenumber', value: e.target.value })} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Permisos</Form.Label>
                        <Form.Control
                            as="select"
                            value={state.role.value}
                            onChange={(e) => dispatch({ type: 'UPDATE', param: 'role', value: e.target.value })}>
                            <option value="admin">Administrador</option>
                            <option value="repair">Reparador</option>
                            <option value="power_user">Super Usuario</option>
                            <option value="user">Usuario</option>
                        </Form.Control>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.hide}>Cerrar</Button>
                <Button variant="success" onClick={onSubmit}>Guardar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditModal;